import AbstractComponent from "./abstract-component";


const createTemplate = () => {
  return (
    `<svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
      x="0px" y="0px" viewBox="0 0 40 40" enable-background="new 0 0 0 0" xml:space="preserve" 
      width="20" height="20">
        <rect x="10" y="0" width="4" height="20" fill="#fff">
          <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0" dur="0.6s" repeatCount="indefinite"></animateTransform>
        </rect>
        <rect x="20" y="0" width="4" height="20" fill="#fff">
          <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.2s" dur="0.6s" repeatCount="indefinite"></animateTransform>
        </rect>
        <rect x="30" y="0" width="4" height="20" fill="#fff">
          <animateTransform attributeType="xml" attributeName="transform" type="translate" values="0 0; 0 20; 0 0" begin="0.4s" dur="0.6s" repeatCount="indefinite"></animateTransform>
        </rect>
    </svg>`
  );
};


export default class LoaderColumnSvgComponent extends AbstractComponent {
  getTemplate() {
    return createTemplate();
  }
}
